import React from 'react';

export default function AboutApp() {
    return (
        <>
            <div>
                <h1>About App.</h1>
                <p>Lorem ipsum About Us.About Us.About Us.About Us.About Us.About Us.About Us.About Us.About Us.About Us.About Us.About Us.About Us.About Us.About Us.About Us.About Us.About Us.About Us.About Us.About Us.About Us.About Us.About Us.About Us.About Us.About Us.About Us.About Us.About Us.vAbout Us.About Us.About Us.About Us.About Us.About Us.About Us.About Us.About Us.About Us.About Us.About Us.About Us.About Us.About Us.About Us.About Us.About Us.About Us.About Us.About Us.About Us.About Us.About Us.About Us.About Us.About Us.About Us.About Us.About Us.About Us.About Us.About Us.About Us.About Us.About Us.About Us.About Us.</p>
            </div>
        </>
    );
}